define(["dijits/auth/loginContainer"], function(__WEBPACK_EXTERNAL_MODULE_dijits_auth_loginContainer__) { return webpackJsonp([1],{

/***/ "./source/apps/siteHeaderBar.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _SiteHeaderBar = __webpack_require__("./source/containers/SiteHeaderBar/index.jsx");

var _SiteHeaderBar2 = _interopRequireDefault(_SiteHeaderBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: window.store },
    _react2.default.createElement(_SiteHeaderBar2.default, null)
), document.getElementById('SiteHeaderBar'));

/***/ }),

/***/ "./source/components/auth/LoginWrapper.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _loginContainer = __webpack_require__("dijits/auth/loginContainer");

var _loginContainer2 = _interopRequireDefault(_loginContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginContainer = function (_React$Component) {
    _inherits(LoginContainer, _React$Component);

    function LoginContainer(props) {
        _classCallCheck(this, LoginContainer);

        var _this = _possibleConstructorReturn(this, (LoginContainer.__proto__ || Object.getPrototypeOf(LoginContainer)).call(this, props));

        _this.loginDijit = new _loginContainer2.default({ next: window.location.pathname });
        return _this;
    }

    _createClass(LoginContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loginDijit.placeAt(dojo.byId('LoginButton'));
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement('div', { id: 'LoginButton', className: 'right' });
        }
    }]);

    return LoginContainer;
}(_react2.default.Component);

exports.default = LoginContainer;

/***/ }),

/***/ "./source/components/form/DropDownButton.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownButton = function (_React$Component) {
    _inherits(DropDownButton, _React$Component);

    function DropDownButton(props) {
        _classCallCheck(this, DropDownButton);

        var _this = _possibleConstructorReturn(this, (DropDownButton.__proto__ || Object.getPrototypeOf(DropDownButton)).call(this, props));

        _this.state = {
            open: _this.props.open
        };

        _this.handleButtonClick = _this.handleButtonClick.bind(_this);
        _this.handleClickOutsideMenu = _this.handleClickOutsideMenu.bind(_this);
        return _this;
    }

    _createClass(DropDownButton, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('click', this.handleClickOutsideMenu, true);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this.handleClickOutsideMenu, true);
        }
    }, {
        key: 'handleButtonClick',
        value: function handleButtonClick() {
            if (this.props.disabled) {
                return;
            }
            this.setState(function (prevState) {
                return { open: !prevState.open };
            });
        }
    }, {
        key: 'handleClickOutsideMenu',
        value: function handleClickOutsideMenu(event) {
            var dropDownButton = this.dropDownButton,
                dropDownMenu = this.dropDownMenu;


            if (dropDownMenu && !dropDownMenu.contains(event.target) && !dropDownButton.contains(event.target)) {
                this.setState({ open: false });
            }
        }
    }, {
        key: 'renderOpenButton',
        value: function renderOpenButton() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                {
                    ref: function ref(c) {
                        _this2.dropDownMenu = c;
                    },
                    className: 'dijits_form_dropDownButton_menu dropShadowDark',
                    style: { padding: 0 }
                },
                _react2.default.createElement('div', { className: 'leader leaderRight' }),
                _react2.default.createElement(
                    'div',
                    { style: { width: 'auto' } },
                    this.props.children || null
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                {
                    ref: function ref(c) {
                        _this3.dropDownButton = c;
                    },
                    id: this.props.id,
                    className: 'dijits_form_dropDownButton right ' + this.props.className
                },
                _react2.default.createElement(
                    'div',
                    {
                        role: 'button',
                        tabIndex: 0,
                        className: (0, _classnames2.default)('button', 'small', { disabled: this.props.disabled }),
                        onClick: this.handleButtonClick
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'inline nomargin' },
                        this.props.label && _react2.default.createElement(
                            'span',
                            { className: 'dijitInline' },
                            this.props.label
                        ),
                        '\xA0',
                        _react2.default.createElement('span', { className: 'dijitInline dropDownImageNode' })
                    )
                ),
                this.state.open && this.renderOpenButton()
            );
        }
    }]);

    return DropDownButton;
}(_react2.default.Component);

DropDownButton.defaultProps = {
    label: '',
    open: false,
    disabled: false,
    id: '',
    className: ''
};

exports.default = DropDownButton;

/***/ }),

/***/ "./source/containers/SiteHeaderBar/AccountDropDown.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _immutable = __webpack_require__("./source/utils/immutable.js");

var _DropDownButton = __webpack_require__("./source/components/form/DropDownButton.jsx");

var _DropDownButton2 = _interopRequireDefault(_DropDownButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccountDropDown = function (_React$Component) {
    _inherits(AccountDropDown, _React$Component);

    function AccountDropDown(props) {
        _classCallCheck(this, AccountDropDown);

        var _this = _possibleConstructorReturn(this, (AccountDropDown.__proto__ || Object.getPrototypeOf(AccountDropDown)).call(this, props));

        _this.isGatewayAdmin = props.gateway && props.adminForGateways.some(function (adminGateway) {
            return adminGateway.id === props.gateway;
        });
        return _this;
    }

    _createClass(AccountDropDown, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _DropDownButton2.default,
                    { title: this.props.fullName, label: this.props.fullName },
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'ul',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: this.props.absoluteUrl },
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    gettext('View & Edit Profile')
                                )
                            ),
                            _react2.default.createElement(
                                'a',
                                { href: Util.reverseURL('dbauth:account_settings') },
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    gettext('Account Settings')
                                )
                            ),
                            (this.isGatewayAdmin || !!this.props.permissions.length) && _react2.default.createElement(
                                'a',
                                { href: Util.reverseURL('admin:home') },
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    gettext('Admin Home')
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'ul',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: Util.reverseURL('dbauth:logout') },
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    gettext('Sign Out')
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement('img', {
                    className: 'right',
                    src: this.props.thumbnailUrl,
                    style: { height: 22, background: this.props.thumbnailBackground },
                    alt: this.props.fullName
                })
            );
        }
    }]);

    return AccountDropDown;
}(_react2.default.Component);

AccountDropDown.defaultProps = {
    gateway: '',
    permissions: [],
    adminForGateways: [],
    thumbnailBackground: ''
};

var mapStateToProps = function mapStateToProps(state) {
    return _extends({ gateway: state.getIn(['site', 'gateway']) }, state.get('people').filter((0, _immutable.keyIn)('absoluteUrl', 'permissions', 'adminForGateways', 'fullName', 'thumbnailUrl')).toJS());
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(AccountDropDown);

/***/ }),

/***/ "./source/containers/SiteHeaderBar/LanguageDropDown.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _DropDownButton = __webpack_require__("./source/components/form/DropDownButton.jsx");

var _DropDownButton2 = _interopRequireDefault(_DropDownButton);

var _immutable = __webpack_require__("./source/utils/immutable.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LanguageDropDown = function (_React$Component) {
    _inherits(LanguageDropDown, _React$Component);

    function LanguageDropDown(props) {
        _classCallCheck(this, LanguageDropDown);

        var _this = _possibleConstructorReturn(this, (LanguageDropDown.__proto__ || Object.getPrototypeOf(LanguageDropDown)).call(this, props));

        _this.state = { selectedLanguage: '' };

        _this.handleLanguageClick = _this.handleLanguageClick.bind(_this);
        return _this;
    }

    _createClass(LanguageDropDown, [{
        key: 'handleLanguageClick',
        value: function handleLanguageClick(e) {
            var _this2 = this;

            this.setState({ selectedLanguage: e.target.dataset.langCode }, function () {
                return _this2.languageForm.submit();
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (this.props.gateway && !this.props.isGatewayLocalized) {
                return null;
            }

            return _react2.default.createElement(
                _DropDownButton2.default,
                { id: 'LanguageChooser', label: this.props.currentLanguage },
                _react2.default.createElement(
                    'form',
                    {
                        ref: function ref(c) {
                            _this3.languageForm = c;
                        },
                        method: 'post',
                        action: Util.reverseURL('dblocale:set_databasin_language')
                    },
                    _react2.default.createElement('input', { name: 'next', type: 'hidden', value: window.location.pathname }),
                    _react2.default.createElement('input', { name: 'language', type: 'hidden', value: this.state.selectedLanguage }),
                    _react2.default.createElement(
                        'ul',
                        { style: { fontSize: '1.2em' }, className: 'languageList' },
                        this.props.languages.map(function (lang) {
                            return _react2.default.createElement(
                                'li',
                                {
                                    key: lang.code,
                                    className: 'languageOption',
                                    'data-lang-code': lang.code,
                                    style: { textTransform: 'capitalize' },
                                    onClick: _this3.handleLanguageClick
                                },
                                lang.name_local
                            );
                        })
                    )
                )
            );
        }
    }]);

    return LanguageDropDown;
}(_react2.default.Component);

LanguageDropDown.defaultProps = {
    languages: [],
    gateway: '',
    isGatewayLocalized: false
};

var mapStateToProps = function mapStateToProps(state) {
    return state.get('site').filter((0, _immutable.keyIn)('currentLanguage', 'languages', 'gateway', 'isGatewayLocalized')).toJS();
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(LanguageDropDown);

/***/ }),

/***/ "./source/containers/SiteHeaderBar/Message.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Message(props) {
    return _react2.default.createElement(
        'div',
        { className: 'right withCount', title: gettext('My Messages') },
        _react2.default.createElement(
            'a',
            { href: Util.reverseURL('workspace:messages') },
            _react2.default.createElement('div', { className: 'Icons_28px messageIcon', style: { height: 22, marginTop: -2 } }),
            !!props.messageCount && _react2.default.createElement(
                'div',
                { id: 'HeaderMessageCount', className: 'count roundBorder6 dropShadowDark' },
                props.messageCount
            )
        )
    );
}

Message.defaultProps = {
    messageCount: 0
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        messageCount: state.getIn(['people', 'messageCount'])
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Message);

/***/ }),

/***/ "./source/containers/SiteHeaderBar/Notifications.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Notifications(props) {
    return _react2.default.createElement(
        'div',
        { className: 'withCount right cursorPointer', id: 'HeaderNotifications', title: gettext('Notifications') },
        _react2.default.createElement('img', { src: props.staticUrl + 'img/NotificationIcon_20px.png', alt: 'notifications' }),
        _react2.default.createElement(
            'span',
            { className: 'count roundBorder6 dropShadowDark dijitHidden' },
            '0'
        )
    );
}

var mapStateToProps = function mapStateToProps(state) {
    return { staticUrl: state.getIn(['site', 'staticUrl']) };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Notifications);

/***/ }),

/***/ "./source/containers/SiteHeaderBar/SignInDropDown.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return _react2.default.createElement(
        _DropDownButton2.default,
        { className: 'strong', label: gettext('Sign In') },
        _react2.default.createElement(_LoginWrapper2.default, null)
    );
};

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _DropDownButton = __webpack_require__("./source/components/form/DropDownButton.jsx");

var _DropDownButton2 = _interopRequireDefault(_DropDownButton);

var _LoginWrapper = __webpack_require__("./source/components/auth/LoginWrapper.jsx");

var _LoginWrapper2 = _interopRequireDefault(_LoginWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./source/containers/SiteHeaderBar/SupportDropDown.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _DropDownButton = __webpack_require__("./source/components/form/DropDownButton.jsx");

var _DropDownButton2 = _interopRequireDefault(_DropDownButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SupportDropDown(props) {
    return _react2.default.createElement(
        _DropDownButton2.default,
        { label: gettext('Support') },
        _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
                'a',
                { href: Util.reverseURL('general:help_page') },
                _react2.default.createElement(
                    'li',
                    null,
                    gettext('Site Help')
                )
            ),
            !props.gateway && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'a',
                    { href: Util.reverseURL('services:list') },
                    _react2.default.createElement(
                        'li',
                        null,
                        gettext('Support Services')
                    )
                ),
                _react2.default.createElement(
                    'a',
                    { href: Util.reverseURL('services:site_feedback') },
                    _react2.default.createElement(
                        'li',
                        null,
                        gettext('Send Us Feedback')
                    )
                )
            ),
            _react2.default.createElement(
                'a',
                { href: Util.reverseURL('services:contact') },
                _react2.default.createElement(
                    'li',
                    null,
                    gettext('Contact Us')
                )
            )
        )
    );
}

SupportDropDown.defaultProps = {
    gateway: ''
};

exports.default = SupportDropDown;

/***/ }),

/***/ "./source/containers/SiteHeaderBar/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _immutable = __webpack_require__("./source/utils/immutable.js");

var _AccountDropDown = __webpack_require__("./source/containers/SiteHeaderBar/AccountDropDown.jsx");

var _AccountDropDown2 = _interopRequireDefault(_AccountDropDown);

var _LanguageDropDown = __webpack_require__("./source/containers/SiteHeaderBar/LanguageDropDown.jsx");

var _LanguageDropDown2 = _interopRequireDefault(_LanguageDropDown);

var _Message = __webpack_require__("./source/containers/SiteHeaderBar/Message.jsx");

var _Message2 = _interopRequireDefault(_Message);

var _Notifications = __webpack_require__("./source/containers/SiteHeaderBar/Notifications.jsx");

var _Notifications2 = _interopRequireDefault(_Notifications);

var _SignInDropDown = __webpack_require__("./source/containers/SiteHeaderBar/SignInDropDown.jsx");

var _SignInDropDown2 = _interopRequireDefault(_SignInDropDown);

var _SupportDropDown = __webpack_require__("./source/containers/SiteHeaderBar/SupportDropDown.jsx");

var _SupportDropDown2 = _interopRequireDefault(_SupportDropDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SiteHeader(props) {
    var liveMapLogo = null;
    if (props.liveMapPage) {
        if (props.gateway) {
            liveMapLogo = _react2.default.createElement(
                'h3',
                { className: 'gatewayLiveMapLogo left', style: { padding: '7px 0 0 10px' } },
                props.siteName
            );
        } else {
            liveMapLogo = _react2.default.createElement(
                'div',
                { id: 'logo' },
                _react2.default.createElement('img', {
                    style: { height: '30px' },
                    src: props.staticUrl + 'img/dataBasinLogo-trans.png',
                    alt: 'Data Basin'
                })
            );
        }
    }

    var userMenu = [];
    if (props.userId) {
        userMenu = [_react2.default.createElement(
            'div',
            { key: 'account', className: 'right', style: { marginLeft: 24 } },
            _react2.default.createElement(_AccountDropDown2.default, null)
        ), _react2.default.createElement(_Notifications2.default, { key: 'notifications' }), _react2.default.createElement(_Message2.default, { key: 'message' })];
    } else {
        userMenu = [_react2.default.createElement(_SignInDropDown2.default, { key: 'signIn' }), _react2.default.createElement(
            'div',
            { key: 'signUp', className: 'right' },
            _react2.default.createElement(
                'a',
                { style: { paddingRight: 6 }, href: Util.reverseURL('dbauth:create_account') },
                pgettext('Sign up for an account', 'Sign Up')
            )
        )];
    }

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'a',
            { href: '/' },
            liveMapLogo
        ),
        _react2.default.createElement(
            'div',
            { id: 'SiteHeaderMenu', className: 'right' },
            _react2.default.createElement(_LanguageDropDown2.default, null),
            _react2.default.createElement(_SupportDropDown2.default, { gateway: props.gateway }),
            userMenu
        ),
        _react2.default.createElement(
            'div',
            { style: { display: 'none' } },
            '/* Duplicated from above to ensure capture in djangojs.po */',
            pgettext('Sign up for an account', 'Sign Up')
        ),
        _react2.default.createElement('div', { className: 'clear' })
    );
}

SiteHeader.defaultProps = {
    gateway: null,
    userId: null
};

var mapStateToProps = function mapStateToProps(state) {
    return _extends({ userId: state.getIn(['people', 'userId']) }, state.get('site').filter((0, _immutable.keyIn)('siteName', 'staticUrl', 'gateway', 'liveMapPage')).toJS());
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SiteHeader);

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/babel-polyfill/lib/index.js");
module.exports = __webpack_require__("./source/apps/siteHeaderBar.jsx");


/***/ }),

/***/ "dijits/auth/loginContainer":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_dijits_auth_loginContainer__;

/***/ })

},[2])});;


// WEBPACK FOOTER //
// siteHeaderBar.js